export default __webpack_public_path__ + "static/illustration-spain.url-25a69f02b10a958153899b83f0ea71be.svg";